import { TextArea } from "../FormElements";
import { ReplaceWithDataSource } from "../helpers/variable";

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<>
			<TextArea
				label="Text"
				value={cue.text}
				placeholder="Text goes here..."
				onChange={(value) => {
					onUpdate({
						text: value,
					});
				}}
			/>
		</>
	);
};

export const GraphicCueContent = ({ cue }) => {
	return (
		<div className="overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg whitespace-nowrap overflow-hidden">
			<span className="font-semibold">
				{<ReplaceWithDataSource text={cue.text || "Text"} keepBrakets={true} styled={true} />}
			</span>
		</div>
	);
};
